import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const fetchAllReferralUsers = createAsyncThunk(
  'referral/fetchAll',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await api.get('/admin/referrals', { params: filters });
      console.log("Fetched referral users response:", response.data);
      return response.data.data || response.data; // Handle both response formats
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch referral users");
    }
  }
);

export const deleteReferralUser = createAsyncThunk(
  'referral/delete',
  async (referralId, { rejectWithValue }) => {
    try {
      await api.delete(`/admin/referrals/${referralId}`);
      return referralId;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete referral user");
    }
  }
);